import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  clinicName: "",
};

export const clinicSlice = createSlice({
  name: "clinicSlice",
  initialState,
  reducers: {
    setClinicName: (state, action) => {
      state.clinicName = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setClinicName } = clinicSlice.actions;

export default clinicSlice.reducer;
